import { DEFAULT_COLOR_MAP } from '../customFields/StatusField';
import { ValueOf } from '../utilities/types';

const pingStatuses = {
  PENDING: 'pending',
  RESOLVED: 'resolved',
  CONFIRMED: 'confirmed',
  IGNORED: 'ignored',
} as const;

export type PingStatuses = ValueOf<typeof pingStatuses>;

export const pingStatusChoices = [
  { id: pingStatuses.PENDING, name: 'Pending' },
  { id: pingStatuses.RESOLVED, name: 'Resolved' },
  { id: pingStatuses.CONFIRMED, name: 'Confirmed' },
  { id: pingStatuses.IGNORED, name: 'Ignored' },
];

export const managePingStatusChoices = [
  { id: pingStatuses.CONFIRMED, name: 'Confirmed', color: DEFAULT_COLOR_MAP.Confirmed.dot },
  { id: pingStatuses.RESOLVED, name: 'Resolved', color: DEFAULT_COLOR_MAP.Resolved.dot },
  { id: pingStatuses.IGNORED, name: 'Ignored', color: DEFAULT_COLOR_MAP.Ignored.dot },
];

export default pingStatuses;
